import React, { useState, useEffect, useRef } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, chakra, Box, Text, Button, Flex, useToast, Input, InputGroup, InputRightElement, Select, Icon, IconButton, Spacer, HStack } from '@chakra-ui/react'
import { Slider, SliderTrack, SliderFilledTrack, SliderThumb, SliderMark, Tooltip } from '@chakra-ui/react'
import DatePicker from 'react-date-picker';
import '../css/DatePicker.css';
import '../css/Calendar.css';
import '../css/App.css'
import { RiCloseFill } from "react-icons/ri";
import { FaRegCalendarTimes, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';

import TableHead from '../GlobalComponents/TableHead';
import WebsiteHeader from '../GlobalComponents/WebsiteHeader';
import { ErrorToast, WarnToast, InfoToast, CheckToast } from '../GlobalComponents/CustomToast';
import { ManifestFilterComp } from '../GlobalComponents/ManifestFilterComp';


export default function ManifestSucheTable(props) {

    const SortRef = React.useRef();

    const [page, setPage] = useState(0);
    const [sliderValue, setSliderValue] = React.useState(1)
    const [showTooltip, setShowTooltip] = React.useState(false)

    const pageSize = 25;
    const start = page * pageSize;
    const end = start + pageSize;
    const totalPages = Math.ceil(props.FilteredManifestData.length / pageSize);
    const currentPageData = props.FilteredManifestData.slice(start, end);

    const handlePrev = () => updatePage(Math.max(0, page - 1));
    const handleNext = () => updatePage(Math.min(totalPages - 1, page + 1));

    const updatePage = (p) => {
        setSliderValue(p + 1)
        setPage(p)
    }

    useEffect(() => {

        InitSearchTable();

    }, []);

    //serverside filtering
    const tourInputRef = React.useRef();
    const teamInputRef = React.useRef();
    const driverInputRef = React.useRef();
    const manifInputRef = React.useRef();
    const [Changed, setChanged] = useState(false);

    const clearInput = (ref) => {
        if (ref.current && ref.current.value) {
            ref.current.value = ""
        }
        setChanged(true)
    }

    const SearchFilteredManifest = async () => {

        setChanged(false)

        var tour = tourInputRef.current?.value
        var team = teamInputRef.current?.value
        var driver = driverInputRef.current?.value
        var manifest = manifInputRef.current?.value

        var params = {
            tour: tour,
            team: team,
            driver: driver,
            manifest: manifest
        }

        var result = await props.searchTableCall('get_filter_m', params);

        if (result) {
            updatePage(0)
        }

        //console.log(result); //debug
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            SearchFilteredManifest();
        }
    };

    //-----------------------------------------------

    const InitSearchTable = async () => {

        var result = await props.searchTableCall('init');

        if (tourInputRef.current) tourInputRef.current.value = props.PersFilterValue.tour;
        if (teamInputRef.current) teamInputRef.current.value = props.PersFilterValue.team;
        if (driverInputRef.current) driverInputRef.current.value = props.PersFilterValue.driver;
        if (manifInputRef.current) manifInputRef.current.value = props.PersFilterValue.manifest;

        /*
        if (result !== false) {
            sortingReciever('makeFilter', result);
        } else {
            console.log(props.PersFilterValue);
            sortingReciever('setFilter', props.PersFilterValue);
        }
        */
    }
    const SearchManifHandle = async () => {

        var result = await props.searchTableCall('seak_m');
        //console.log(result); //debug
        sortingReciever('makeFilter', result);
    }

    const columns = [
        { label: 'Tour', accessor: 'Tour', sortable: true, width: 100 },
        { label: 'Fahrer', accessor: 'Fahrer_Name', sortable: true, width: 100 },
        { label: 'Manifestnummer', accessor: 'Manifestnummer', sortable: true, width: 100 },
        { label: 'Abladestellen', accessor: 'Ablade_Anzahl', sortable: true, width: 40 },
        { label: 'Lieferstellen', accessor: 'Liefer_Anzahl', sortable: true, width: 40 },
        { label: 'Pakete', accessor: 'Pakete_Anzahl', sortable: true, width: 40 },
        { label: 'Papier', accessor: 'Papier_Anzahl', sortable: true, width: 40 },
        { label: 'Datum', accessor: 'Datum', sortable: true, width: 40 },
    ]

    const handleSorting = (sortField, sortOrder) => {
        if (sortField) {
            const sorted = [...props.FilteredManifestData].sort((a, b) => {
                if (a[sortField] === null) return 1;
                if (b[sortField] === null) return -1;
                if (a[sortField] === null && b[sortField] === null) return 0;
                return (
                    a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
                        numeric: true,
                    }) * (sortOrder === "asc" ? 1 : -1)
                );
            });
            props.searchTableCall('sort_t', sorted)
        }
    };

    const sortingReciever = (comand, value1, value2) => {
        if (SortRef.current) {
            SortRef.current.Reciever(comand, value1, value2);
        }
    };

    const EditButtonHandler = () => {

        //var manifIndex = props.FilteredManifestData.findIndex((item) => item.Manifestnummer == props.selected)
        if (props.UserRights.tour_manage_all || props.UserRights.tour_manage) {

            return <Button m={2} bg='#1DA1F2' color='#fff'
                //onClick={() => [_fetchData(curentManifest.Manifestnummer, 'sort'), transformRoute(curentManifest.Manifestnummer)]}
                onClick={() => {
                    props.searchTableCall('open_e');
                }}
            >Manifest Bearbeiten</Button>
        } else {
            return <Button m={2} bg='#1DA1F2' color='#fff' isDisabled={true}>Manifest Bearbeiten</Button>
        }
    }
    const colorMaker = (Status) => {
        if (Status === 'complete') {
            return '#b8edc6'
        } else if (Status === null) {
            return 'azure'
        } else if (Status === 'live' || Status === 'prepare') {
            return '#fdd386'
        } else {
            return '#fcb1b1'
        }
    }

    return (
        <Flex flexDirection='column' height='100vh'>
            <WebsiteHeader Text='TourPortal / Manifest Suche' onClick={() => props.searchTableCall('back')} server={props.server} User={props.ActiveUser} />

            <Flex flex={1} backgroundColor='#ccc' p={1} flexDirection='column'>

                <Flex bg='#fff' alignItems='center' justifyContent='flex-start' flexWrap='wrap'
                    mb={1} borderWidth={1} borderColor='#000' borderRadius={3} >

                    <Flex m={2} pr={2} width='450px' height='40px' border='0px solid black' alignItems='center' justifyContent='space-between' borderRadius={5} bg='#1DA1F2'>

                        <IconButton bg='#1DA1F2' color='#fff' width='40px' borderRadius='5px 0px 0px 5px'
                            icon={<Icon as={FaRegCalendarTimes} color='#fff' boxSize={25} />} onClick={() => [props.searchTableCall('setdays'), setChanged(true)]}
                        />
                        <Text color='#fff' fontWeight='semibold' fontSize={19} >von:</Text>
                        <DatePicker onChange={(value) => [props.searchTableCall('date_1', value), setChanged(true)]} value={props.Date1} format='dd.MM.y' border='0px solid black' />
                        <Text color='#fff' fontWeight='semibold' fontSize={19} >bis:</Text>
                        <DatePicker onChange={(value) => [props.searchTableCall('date_2', value), setChanged(true)]} value={props.Date2} format='dd.MM.y' border='0px solid black' />
                    </Flex>

                    {/*
                        <ManifestFilterComp ref={SortRef} FilterCall={props.FilterCall} ManifestArrayOrigin={props.ManifestData} PersFilterData={props.PersFilterData} 
                        HideTeamFilter={ !props.UserRights.tour_view_all} HideDriverFilter={ !props.UserRights.tour_view_all}/>
                    */}

                    <Flex m={2} width='220px' height='40px' border='0px solid black' alignItems='center' borderRadius={6} pl={1} bg='#1DA1F2'>
                        <Text ml={1} color='#fff' fontWeight='semibold' fontSize={19} width='90px'>Tour:</Text>
                        <Flex width='100%' height='40px' alignItems='center'>
                            <Input border='0px solid black' borderRadius={0} fontSize={17} bg='#fff' height='36px' padding={2}
                                ref={tourInputRef} onChange={() => setChanged(true)} onKeyDown={handleKeyDown}
                            ></Input>
                        </Flex>
                        <IconButton bg='#1DA1F2' borderRadius='0px 5px 5px 0px' color='#fff' width='40px'
                            onClick={() => clearInput(tourInputRef)}
                            icon={<Icon as={RiCloseFill} color='#fff' boxSize={35} />}
                        />
                    </Flex>

                    <Flex m={2} width='240px' height='40px' border='0px solid black' alignItems='center' borderRadius={6} pl={1} bg='#1DA1F2'>
                        <Text ml={1} color='#fff' fontWeight='semibold' fontSize={19} width='100px'>Team:</Text>
                        <Flex width='100%' height='40px' alignItems='center'>
                            <Input border='0px solid black' borderRadius={0} fontSize={17} bg='#fff' height='36px' padding={2}
                                ref={teamInputRef} onChange={() => setChanged(true)} onKeyDown={handleKeyDown}
                            ></Input>
                        </Flex>
                        <IconButton bg='#1DA1F2' borderRadius='0px 5px 5px 0px' color='#fff' width='20px'
                            onClick={() => clearInput(teamInputRef)}
                            icon={<Icon as={RiCloseFill} color='#fff' boxSize={35} />} />
                    </Flex>

                    <Flex m={2} width='280px' height='40px' border='0px solid black' alignItems='center' borderRadius={6} pl={1} bg='#1DA1F2'>
                        <Text ml={1} color='#fff' fontWeight='semibold' fontSize={19} width='110px'>Fahrer:</Text>
                        <Flex width='100%' height='40px' alignItems='center'>
                            <Input border='0px solid black' borderRadius={0} fontSize={17} bg='#fff' height='36px' padding={2}
                                ref={driverInputRef} onChange={() => setChanged(true)} onKeyDown={handleKeyDown}
                            ></Input>
                        </Flex>
                        <IconButton bg='#1DA1F2' borderRadius='0px 5px 5px 0px' color='#fff' width='20px'
                            onClick={() => clearInput(driverInputRef)}
                            icon={<Icon as={RiCloseFill} color='#fff' boxSize={35} />} />
                    </Flex>
                    <Flex m={2} width='240px' height='40px' border='0px solid black' alignItems='center' borderRadius={6} pl={1} bg='#1DA1F2'>
                        <Text ml={1} color='#fff' fontWeight='semibold' fontSize={19} width='190px'>Manifest:</Text>
                        <Flex width='100%' height='40px' alignItems='center'>
                            <Input border='0px solid black' borderRadius={0} fontSize={17} bg='#fff' height='36px' padding={2}
                                ref={manifInputRef} onChange={() => setChanged(true)} onKeyDown={handleKeyDown}
                            ></Input>
                        </Flex>
                        <IconButton bg='#1DA1F2' borderRadius='0px 5px 5px 0px' color='#fff' width='20px'
                            onClick={() => clearInput(manifInputRef)}
                            icon={<Icon as={RiCloseFill} color='#fff' boxSize={35} />} />
                    </Flex>

                    <Button onClick={() => SearchFilteredManifest()} bg='#1DA1F2' color='#fff' borderRadius='5px' m={2} width={82} position='relative'>
                        <Text fontWeight='semibold' fontSize={19}>Suche</Text>
                        {Changed && (
                            <Box position="absolute" top="-1" right="-1" height="17px" width="17px" borderRadius="full" bgColor="red" border="2px solid white" />
                        )}
                    </Button>

                </Flex>
                {/*props.selected !== '' ? (
                    <Box display='flex' h='65px' bg='#fff' alignItems='center' justifyContent='flex-start' mb={1} borderWidth={1} borderColor='#000' borderRadius={3} >
                        <>
                            <Button m={2} bg='#1DA1F2' color='#fff' isDisabled={!props.UserRights.tour_view} onClick={() => {
                                //setSubSection('view')

                                props.searchTableCall('open_v')

                                //_fetchData(curentManifest.Manifestnummer, 'view'), 
                                //transformRoute(curentManifest.Manifestnummer)
                            }}>Manifest Anschauen</Button>
                            {EditButtonHandler()}
                        </>
                    </Box>
                ) : (null)*/}

                <Flex flex={1} flexDirection='column' bg='#fff' alignItems='center' justifyContent='flex-start' borderWidth={1} borderColor='#000' borderRadius={3} padding={2} overflow='auto'>
                    <Table size="small">
                        <TableHead {...{ columns, handleSorting }} />
                        <Tbody>
                            {currentPageData.map((row, index) => {
                                return (

                                    <Tr key={row.Manifestnummer}
                                        onClick={(e) => (e.stopPropagation(), e.preventDefault(), props.searchTableCall('select', index + pageSize * page))}
                                        bg={() => colorMaker(row.Status)}
                                        border={props.selected === row.Manifestnummer ? '3px dashed #0060d5' : null}
                                    >
                                        {columns.map(({ accessor }) => {
                                            const tData = row[accessor];
                                            return (<React.Fragment key={accessor}>
                                                <Td textAlign="center" borderWidth={1} >
                                                    <Text noOfLines={1}>{tData}</Text>
                                                </Td>
                                                <Td className="columnResizer" />
                                            </React.Fragment>
                                            );
                                        })}
                                    </Tr>
                                );
                            })}
                        </Tbody>
                    </Table>
                    {totalPages > 1 ? (
                        <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' overflow='auto'>
                            <HStack justify="space-between" mt={4}>

                                <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                    onClick={() => updatePage(0)} isDisabled={page === 0}
                                    icon={<Icon as={FaAngleDoubleLeft} boxSize={25} />} />
                                <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                    onClick={handlePrev} isDisabled={page === 0}
                                    icon={<Icon as={FaAngleLeft} boxSize={25} />} />

                                <Text style={{ fontSize: 23 }}>Seite {page + 1} von {totalPages}</Text>

                                <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                    onClick={handleNext} isDisabled={page === totalPages - 1}
                                    icon={<Icon as={FaAngleRight} boxSize={25} />} />
                                <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                    onClick={() => updatePage(totalPages - 1)} isDisabled={page === totalPages - 1}
                                    icon={<Icon as={FaAngleDoubleRight} boxSize={25} />} />

                            </HStack>

                            <Slider
                                height='50px'
                                width='300px'
                                id='slider'
                                defaultValue={1}
                                min={1}
                                max={totalPages}
                                value={sliderValue}
                                color='#fff'
                                onChangeEnd={(val) => setPage(val - 1)}
                                onChange={(v) => setSliderValue(v)}
                                onMouseEnter={() => setShowTooltip(true)}
                                onMouseLeave={() => setShowTooltip(false)}
                            >
                                <SliderTrack>
                                    <SliderFilledTrack />
                                </SliderTrack>
                                <Tooltip
                                    hasArrow
                                    color='#fff'
                                    placement='top'
                                    isOpen={showTooltip}
                                    label={sliderValue}
                                >
                                    <SliderThumb>
                                        <Box height="20px" width="20px" borderWidth={3} borderColor="#1DA1F2" />
                                    </SliderThumb>
                                </Tooltip>
                            </Slider>
                        </Box>
                    ) : (null)}
                </Flex>
            </Flex>
        </Flex >
    );
}